import { Fragment } from "react";
import { OptionItem } from "./OptionItem";

// import { Table } from "../../../core/Table";

import styles from "@/styles/containers/product-details.module.scss";
import { useLocale, useTranslations } from "next-intl";

import classNames from "classnames/bind";
import { CatalogHelpers } from "@/tools";
const css = classNames.bind(styles);

const getTextMinMaxOptions = (question) => {
  const t = useTranslations();

  const min = question?.min;
  const max = question?.max;

  if (min == 0 && max >= 1) return `${t("selectUpTo", { max })}`;

  if (min === max) return `${t("selectExactly", { max })}`;

  if (min >= 1 && !max) return `${t("selectAtLeast", { min })}`;

  if (min >= 1 && min < max) return `${t("selectBetween", { min, max })}`;
};

const checkIsDisabledOption = (question) => {
  const max = question?.max;

  const selectedOptions = question.items.reduce((t, o) => {
    return o.selected ? t + o.quantity : t;
  }, 0);

  if (max && max <= selectedOptions) return true;
};

const formatInputExtra = (question) => {
  switch (true) {
    case question.min === 1 && question.max === 1:
      return true;
    default:
      return false;
  }
};

export const QuestionItem = ({
  question,
  onChange,
  questionSelected,
  onChangeSelectedQuestion,
  highlightError,
}) => {
  const max = question?.max;
  const selectedOptions = question.items.reduce(
    (t, o) => (max > 0 ? Math.min(max, t + o.quantity) : t + o.quantity),
    0
  );

  const handleOptionClick = (option, optionIndex) => {
    question.items[optionIndex] = option;

    if (question.max === 1 && question.min === 1) {
      question.items.forEach((o) => (o.selected = false));
      question.items[optionIndex].selected =
        !question.items[optionIndex].selected;
      question.items[optionIndex].quantity =
        +question.items[optionIndex].selected;
    } else {
      question.items.forEach((o) => {
        if (question.mode == "quantity") {
          o.selected = o.quantity > 0;
          return;
        }

        if (option.id == o.id) {
          o.selected = !o.selected;
          o.quantity = +o.selected;
        }
      });
    }

    const max = question?.max;
    const selectedOptions = question.items.reduce((t, o) => t + o.quantity, 0);

    if (max && max <= selectedOptions)
      onChangeSelectedQuestion(question.id, option);

    onChange(question);
  };

  const locale = useLocale();

  if (question.id !== questionSelected) return;

  return (
    <>
      <div
        className={css({
          sectionHeader: true,
          incomplete: highlightError && selectedOptions < question?.min,
        })}
      >
        <div className="d-flex align-center justify-between w-100">
          <p className={styles.sectionTitle}>
            {CatalogHelpers.getTranslation({
              item: question,
              field: "name",
              locale,
            })}
          </p>
          {(question?.min > 0 || question?.max > 0) && (
            <span className={styles.minQuantity}>
              {getTextMinMaxOptions(question)}
            </span>
          )}
        </div>
      </div>

      <div className={styles.optionItems}>
        {(question.items || []).map((option, optionIndex) => (
          <Fragment key={optionIndex}>
            <OptionItem
              option={option}
              singleOption={formatInputExtra(question)}
              sameOptions={question.mode == "quantity"}
              onClick={(newOption) => {
                handleOptionClick(newOption, optionIndex);
              }}
              disabled={checkIsDisabledOption(question, option)}
            />
          </Fragment>
        ))}
      </div>
    </>
  );
};
